import axios from "libs/axios";
import qs from "qs";

/**
 * 캐치 스토리 삭제 체크 불러오기
 * 1차 삭제 방어 팝업 호출 시
 * @param params
 */
export const fetchStoryHiddenCheck = (
	storyIdx = 0,
	_method = "get",
	reason_delete = false,
) => async () => {

	// url 세팅
	let url = `/${global.bj_id}/vod/storyHidden`;
	storyIdx && (url += `/${storyIdx}`);

	// 파라미터 세팅
	const params = {
		_method : _method,
		reason_delete: reason_delete,
	};

	try {
		// api 호출
		const response = await axios.post(url, qs.stringify(params));

		return response;

	} catch (error) {
		return error;
	}
};

/**
 * 캐치 스토리 삭제
 * 2차 삭제 방어 팝업에서 삭제 시
 * @param params
 */
export const fetchStoryHiddenReason = (
	storyIdx = 0,
	_method = "delete",
	reason_delete = true,
	reason = ""
) => async () => {

	// url 세팅
	let url = `/${global.bj_id}/vod/storyHidden`;
	storyIdx && (url += `/${storyIdx}`);

	// 파라미터 세팅
	const params = {
		_method : _method,
		reason_delete: reason_delete,
		reason: reason,
	};

	try {
		// api 호출
		const response = await axios.post(url, qs.stringify(params));

		return response;

	} catch (error) {
		return error;
	}
};
